import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";

export default function VideoGrid() {
  const featuredVideos = videos.filter((v) =>
    ["91-video", "97-video"].includes(v.category)
  ).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 max-w-screen-2xl mx-auto bg-background-100/50">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            精选视频
          </h2>
          <p className="text-sm text-foreground-600 mt-1">91视频与97视频精选内容，每日更新</p>
        </div>
        <Link
          to="/category/91-video"
          className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer font-medium whitespace-nowrap flex items-center gap-1"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {featuredVideos.map((video) => (
          <Link
            key={video.id}
            to={`/article/${video.id}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
            data-product-shop=""
          >
            <div className="relative w-full aspect-video overflow-hidden">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 樱花视频`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                {video.duration}
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-3">
                {video.description}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{video.views}次观看</span>
                <span>{video.date}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}